import React from 'react';
import './PromptDetails.css';

const PromptMetadata = ({ prompt }) => {
  if (!prompt.creatorEmail) {
    return null;
  }

  return (
    <div className="prompt-creator-email">
      {prompt.creatorEmail}
    </div>
  );
};

export default PromptMetadata;

